import React, {ReactElement, useState} from 'react';
import Lightbox from 'yet-another-react-lightbox';
import Counter from 'yet-another-react-lightbox/plugins/counter';
import Download from 'yet-another-react-lightbox/plugins/download';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import NobulaLogo from '../../../../assets/icons/NobulaLogo.svg';
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/counter.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import useDraggingDetection from '../../../hooks/useDraggingDetection';
import {IElementImageGallery} from '../../../incase-domain/elements/imageGallery';

interface ElementImageGalleryComponentProps {
    element: IElementImageGallery;
}
function ElementImageGalleryComponent(props: ElementImageGalleryComponentProps): ReactElement {
    const {element} = props;
    const {images, numberOfImagesInARow, imageMargin} = element;

    const [open, setOpen] = useState(false);
    const [slideIndex, setSlideIndex] = useState<number | undefined>(undefined);
    const [handleMouseDown, handleMouseMove, handleMouseUp] = useDraggingDetection<number>({
        onDraggingStop: (data) => {
            setOpen(true);
            setSlideIndex(data);
        },
    });

    const imageSlides = images.map((image) => {
        return {src: image.imageSrc};
    });

    const showButtons = imageSlides.length <= 1 ? () => null : undefined;

    const marginsStyle = {
        marginLeft: `${imageMargin}em`,
        marginRight: `${imageMargin}em`,
    } as React.CSSProperties;

    return (
        <>
            <div style={{display: 'grid', gridTemplateColumns: `repeat(${numberOfImagesInARow}, 1fr)`}}>
                {images.length === 0
                    ? [...Array(numberOfImagesInARow)].map((_, index) => {
                          return <img key={index} width="100%" height="auto" src={NobulaLogo} alt="" />;
                      })
                    : images?.map((image, index) => {
                          return (
                              <div
                                  key={index}
                                  onMouseDown={(e) => {
                                      if (e.button !== 2) {
                                          handleMouseDown(e);
                                      }
                                  }}
                                  onMouseMove={(e) => {
                                      if (e.button !== 2) {
                                          handleMouseMove(e);
                                      }
                                  }}
                                  onMouseUp={(e) => {
                                      if (e.button !== 2) {
                                          handleMouseUp(index);
                                      }
                                  }}
                                  style={{...marginsStyle}}
                              >
                                  <img width="100%" height="auto" src={image.imageSrc} alt="" />
                              </div>
                          );
                      })}
            </div>
            <Lightbox
                open={open}
                close={() => {
                    setOpen(false);
                    setSlideIndex(undefined);
                }}
                slides={imageSlides}
                index={slideIndex}
                plugins={[Counter, Download, Fullscreen, Slideshow, Thumbnails, Zoom]}
                counter={{container: {style: {top: 'unset', bottom: 0}}}}
                animation={{zoom: 500}}
                render={{
                    buttonPrev: showButtons,
                    buttonNext: showButtons,
                    iconSlideshowPlay: showButtons,
                }}
                zoom={{
                    scrollToZoom: true,
                    maxZoomPixelRatio: 5,
                }}
            />
        </>
    );
}

export default ElementImageGalleryComponent;
